import { useMemo } from "react";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { Button, Input } from "expano-components";

import { Dashboard, Select } from "components";

import useGet from "hooks/useGet";
import useUpdate from "hooks/useUpdate";

const InputField = (props) => <Input {...props} />;
const SelectField = (props) => <Select {...props} />;

const BasicData = ({
  brand_id,
  refetch,
  initialValues,
  handleSubmit,
  change,
  pristine,
  invalid,
}) => {
  const { is_loading: is_loading_producers, data: producers } = useGet({
    query: ["producers"],
    path: "/producers",
    context: "list",
    search: { per_page: 10_000 },
  });

  const { is_updating, update } = useUpdate({
    path: `/brands/${brand_id}`,
    onSuccess: refetch,
    onError: (err) => {
      throw new SubmissionError(
        Object.fromEntries(
          Object.entries(err).map(([key, value]) => {
            if (["producer", "brand", "root_taxon"].includes(key)) {
              return [`${key}_id`, value];
            }
            return [key, value];
          })
        )
      );
    },
  });

  const producer_options = useMemo(() => {
    return producers?.map(({ id, name }) => ({ label: name, value: id }));
  }, [producers]);

  const onSubmit = (values) => update(values);

  return (
    <Dashboard
      header={{ title: "Podstawowe informacje", icon: "info" }}
      footer={
        <>
          <Button
            type="save"
            text={is_updating ? "Proszę czekać..." : "Zapisz"}
            disabled={pristine || invalid || is_updating}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <form
        className="dashboard__form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <Field name="name" label="Nazwa" component={InputField} type="text" />
        <Field name="email" label="E-mail" component={InputField} type="text" />
        <Field
          key={is_loading_producers}
          label="Producent"
          name="producer_id"
          component={SelectField}
          defaultValue={producer_options?.find(
            ({ value }) => value === initialValues.producer_id
          )}
          options={producer_options}
          handleChange={(value) => {
            change("producer_id", value);
          }}
        />
      </form>
    </Dashboard>
  );
};

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Nazwa produktu jest wymagana!";
  }

  if (!values.producer_id) {
    errors.producer_id = "Producent jest wymagany!";
  }

  return errors;
};

export default reduxForm({
  form: "update-brand-basic",
  enableReinitialize: true,
  validate,
})(BasicData);
